<template>
  <div>
    <v-text-field
      ref="input"
      :error-messages="errors"
      :value="manufacturer_name"
      append-icon="mdi-crosshairs"
      class="cursor-pointer"
      dense
      label="انتخاب سطح دسترسی"
      outlined
      readonly
      @click="dialog = true"
    />

    <custom-popup
      v-model="dialog"
      :cons="{ title: 'انتخاب سطح دسترسی' }"
      hide-confirm
    >

      <v-card :loading="loading" class="pa-2" flat outlined>
            <div class="px-4 py-2 justify-space-between d-flex">
            <v-card-title>انتخاب سطح دسترسی</v-card-title>
            
          <v-btn class="btn-delete rounded-lg" outlined @click.stop="clearAllPermissions">
            <v-icon right class="ml-2">mdi-delete-sweep</v-icon>
            حذف کلیه دسترسی ها
          </v-btn>
        </div>


        <v-divider />
        <v-card-text v-if="service == null"
          >لطفا سرویس خود را انتخاب کنید!</v-card-text
        >

        <v-row class="pa-2" no-gutters>
          <v-col class="pa-2" cols="4">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              dense
              label="جستجو"
              outlined
            />
          </v-col>

          <v-col class="pa-2" cols="4">
            <v-select
              v-model="service"
              :items="services"
              dense
              item-text="nameLand"
              item-value="id"
              label="انتخاب سرویس"
              outlined
              return-object
              @change="fetch"
            />
          </v-col>

          <v-col class="pa-2" cols="4">
            <v-select
              v-model="pack"
              :items="packs"
              dense
              item-text="name"
              item-value="id"
              label="انتخاب نقش"
              outlined
              @change="checkList"
            />
          </v-col>
        </v-row>

        <v-expansion-panels popout>
          <v-expansion-panel
            v-for="category in categories.data"
            v-if="category.permission.length"
            :key="category.id"
          >
            <v-expansion-panel-header>
              <v-col>
                <b>
                  {{ category.name + "    " }}
                </b>
              </v-col>

              <v-col v-if="category.meta_title !== null">
                <v-chip
                  v-if="category.meta_title == 'admin'"
                  class="text--white"
                  color="#F44336"
                  style="color: white"
                  >ادمین
                </v-chip>
                <v-chip v-if="category.meta_title == 'user'">کاربر</v-chip>
              </v-col>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <v-flex
                v-for="permission in category.permission"
                :key="permission.id"
              >
                <v-row>
                  <v-col cols="6">
                    <v-row class="justify-content-left">
                      <v-col>
                        <v-card-title class="text-break">{{
                          permission.name_fa
                        }}</v-card-title>
                      </v-col>

                      <v-col class="mt-3">
                        <v-btn
                          class="btn-update"
                          @click="
                            () => {
                              dialogEdit = true;
                              dialogEditInfo.permission = permission;
                              dialogEditInfo.id = permission.id;
                              dialogEditInfo.name_fa = permission.name_fa;
                              dialogEditInfo.name = permission.name;
                              dialogEditInfo.privilege_type =
                                permission.privilege_type;
                            }
                          "
                        >
                          <v-icon dark> mdi-pencil </v-icon>
                        </v-btn>
                      </v-col>

                      <!--                          <div >-->
                      <!--                                                     <v-chip v-if="permission.privilege_type=='admin'" color="#F44336" style="color: white" class="text&#45;&#45;white">ادمین</v-chip>-->
                      <!--                                                      <v-chip v-if="permission.privilege_type=='user'">کاربر</v-chip>-->

                      <!--                          </div>-->

                      <v-col v-if="permission.privilege_type" class="mt-6">
                        <v-chip
                          v-if="permission.privilege_type == 'admin'"
                          class="text--white"
                          color="#F44336"
                          label
                          style="color: white"
                          >ادمین
                        </v-chip>
                        <v-chip v-if="permission.privilege_type == 'user'" label
                          >کاربر
                        </v-chip>
                      </v-col>

                      <v-col v-else class="mt-6">
                        <v-chip
                          class="text--white"
                          color="#999"
                          label
                          style="color: white"
                        >
                          -
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col class="py-2" cols="6">
                    <p>انتخاب وضعیت</p>

                    <v-btn-toggle
                      :value="
                        value[permission.id]
                          ? value[permission.id].type
                          : 'deactive'
                      "
                      borderless
                      color="#2196f3"
                      rounded
                      @change="
                        (erv) => {
                          erfan(erv, permission.id, category.service_id);
                        }
                      "
                    >
                      <v-btn value="active">
                        <span class="hidden-sm-and-down">فعال</span>
                        <v-icon right> mdi-check-circle-outline </v-icon>
                      </v-btn>

                      <v-btn value="deactive">
                        <span class="hidden-sm-and-down">غیرفعال</span>

                        <v-icon right> mdi-cancel </v-icon>
                      </v-btn>

                      <v-btn value="show">
                        <span class="hidden-sm-and-down">فقط مشاهده</span>
                        <v-icon right> mdi-eye </v-icon>
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                </v-row>
              </v-flex>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!--        <v-card-actions>-->
        <!--          <pagination :data="permissions.data" :visible="2" v-on:page="fetch"/>-->

        <!--          <v-spacer/>-->

        <!--          <v-btn color="primary" class="mr-auto" text @click="dialog = false">بستن</v-btn>-->
        <!--        </v-card-actions>-->
      </v-card>
    </custom-popup>

    <v-dialog
      v-model="dialogEdit"
      max-height="200px"
      max-width="400px"
      scrollable
    >
      <v-card :loading="loadingPermissionUpdate">
        <v-card-title>
          ویرایش پرمیشن
          {{ dialogEditInfo.name_fa }}
        </v-card-title>

        <v-divider />
        <v-card-text>
          <v-row class="mt-3">
            <v-text-field
              v-model="dialogEditInfo.name"
              label="عنوان لاتین"
              outlined
              readonly
              required
            />

            <v-text-field
              v-model="dialogEditInfo.name_fa"
              label="توضیح فارسی"
              outlined
              required
            />
          </v-row>

          <v-row class="justify-content-center mt-1">
            <v-label>سطح دسترسی :</v-label>
          </v-row>

          <v-row class="flex-column align-items-center">
            <v-radio-group v-model="dialogEditInfo.privilege_type" row>
              <v-radio color="primary" label="ادمین" value="admin"></v-radio>
              <v-radio color="primary" label="کاربر" value="user"></v-radio>
            </v-radio-group>
          </v-row>

          <v-row class="mt-2 justify-content-center">
            <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
              <v-btn
                block
                class="btn-update"
                @click="getPermissionRoles(dialogEditInfo.id)"
              >
                <v-icon> mdi-domain </v-icon>
                <b>تغییر سرویس</b>
              </v-btn>
            </v-flex>
          </v-row>

          <v-row class="mt-10">
            <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
              <v-btn
                :loading="loadingPermissionUpdate"
                block
                class="btn-record"
                @click="updatePermissionInfo"
              >
                <v-icon> mdi-content-save </v-icon>
                <b>ذخیره</b>
              </v-btn>
            </v-flex>

            <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
              <v-btn block class="btn-back" @click="dialogEdit = false">
                <v-icon> mdi-close </v-icon>
                <b>انصراف</b>
              </v-btn>
            </v-flex>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogPermissionRoles"
      max-height="300px"
      max-width="700px"
      scrollable
    >
      <v-card :loading="loadingPermissionUpdate">
        <v-card-title
          >ویرایش پرمیشن
          {{ dialogEditInfo.name_fa }}
        </v-card-title>

        <v-divider />
        <v-card-text>
          <v-row class="mt-3">
            <v-text-field
              v-model="dialogEditInfo.name"
              disabled
              label="پرمیشن"
              outlined
              readonly
              required
            />

            <v-text-field
              v-model="dialogEditInfo.name_fa"
              disabled
              label="توضیح فارسی"
              outlined
              readonly
              required
            />
          </v-row>

          <v-row>
            <v-select
              v-model="permissionRoleInfo.service_id"
              :items="services"
              dense
              item-text="nameLand"
              item-value="id"
              label="انتخاب سرویس"
              outlined
            />
          </v-row>

          <v-row class="mt-10">
            <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
              <v-btn
                :loading="loadingPermissionUpdate"
                block
                class="btn-record"
                @click="updatePermission"
              >
                <v-icon> mdi-content-save </v-icon>
                <b>ذخیره</b>
              </v-btn>
            </v-flex>

            <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
              <v-btn
                block
                class="btn-back"
                @click="dialogPermissionRoles = false"
              >
                <v-icon> mdi-close </v-icon>
                <b>انصراف</b>
              </v-btn>
            </v-flex>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import pagination from "@/view/pages/pickers/pagination";
import routePagination from "@/view/content/route-pagination";

export default {
  components: { pagination, routePagination },

  name: "permissionPicker",

  props: {
    selectedPermissions: {
      required: true,
    },
    value: {
      type: Object,
      default: {},
    },
    errors: [],
  },

  data() {
    return {
      editCons: {
        title: "ویرایش نقش",
        buttons: [{ text: "", type: "submit", handler: this.updateUserInfo }],
      },
      dialog: false,
      dialogEdit: false,
      dialogPermissionRoles: false,
      loading: false,
      dialogEditInfo: {
        permission: {},
        id: null,
        name_fa: null,
        privilege_type: null,
        name: null,
      },
      permissionRoleInfo: {
        name_fa: null,
        id: null,
        role_id: null,
        service_id: null,
        permission_id: null,
      },
      search: null,
      service: [],
      pack: null,
      permissions: [],
      packs: [],
      loadingPermissionUpdate: false,
      categories: [],
      icon: "justify",
      checkedPermissions: {},
      typePermissions: {},
      servicePermissions: {},
      data: {},
      toggle_none: null,
      showColor: "red darken-3",
      activeColor: "red darken-3",
      deactiveColor: "red darken-3",
      services: [],
      toggle_one: 0,
      toggle_exclusive: 2,
      toggle_multiple: [0, 1, 2],
      model: null,
    };
  },

  async created() {
    try {
      this.services = await this.getService();
    } catch (error) {
      console.error("Failed to fetch services:", error);
      this.$toast.error("خطا در دریافت سرویس‌ها");
    } finally {
    }
    // this.services = this.getService().data;
    this.fetch();
    this.getAllPacks();
  },

  computed: {
    manufacturer_name: function () {
      if (this.model === null) return "";
      return this.model.name;
    },
  },

  watch: {
    search() {
      this.fetch();
    },
  },

  methods: {
        clearAllPermissions() {
          let allPermissions = { ...this.value };          
          Object.keys(allPermissions).forEach(key => {
            let currentData = allPermissions[key];
            
            allPermissions[key] = {
              type: 'deactive',
              service_id: currentData.service_id
            };
          });
          this.$emit("update:selectedPermissions", { ...allPermissions });
          this.$emit("input", allPermissions);
          this.$toast.success("کلیه دسترسی‌ها غیرفعال شدند.");
    },
    erfan(value, id, service_id) {
      if (value === undefined) {
        delete this.selectedPermissions[id];
        return;
      }

      this.selectedPermissions[id] = {
        type: value,
        service_id: service_id,
      };
    },

    checkList() {
      this.loading = true;
      this.requestApiGet("roleShow/" + this.pack)
        .then(({ data }) => {
          for (let a of data.permissions_with_type) {
            this.selectedPermissions[a.pivot.permission_id] = {
              type: a.pivot.type,
              service_id: a.pivot.service_id,
            };
          }

          this.$emit("input", this.selectedPermissions);
        })
        .catch(({ response }) =>
          this.$root.$emit("errorToast", response.data.message)
        )
        .finally(() => (this.loading = false));
    },

    fetch(page = 1) {
      let data = {};
      this.loading = true;
      this.requestApiGet("admin/categoryPermission", {
        search: this.search,
        service_id: this.service.id,
        length: 10000,
      })
        .then(({ data }) => {
          this.categories = data;
        })
        .catch(({ response }) =>
          this.$root.$emit("errorToast", response.data.message)
        )
        .finally(() => (this.loading = false));
    },

    getAllPacks() {
      this.loading = true;
      this.requestApiGet("admin/roles", { length: 10000 })
        .then(({ data }) => {
          this.packs = data.data;
        })
        .catch(({ response }) =>
          this.$root.$emit("errorToast", response.data.message)
        )
        .finally(() => (this.loading = false));
    },
    updatePermissionInfo() {
      this.loadingPermissionUpdate = true;
      this.requestApiPost(`permission/${this.dialogEditInfo.id}`, {
        name: this.dialogEditInfo.name,
        name_fa: this.dialogEditInfo.name_fa,
        privilege_type: this.dialogEditInfo.privilege_type,
        _method: "PUT",
      })
        .then((response) => {
          this.loadingPermissionUpdate = false;
          this.$toast.success(
            "پرمیشن با موفقیت ویرایش شد.برای اعمال تغییرات در این صفحه رفرش کنید."
          );
          this.dialogEdit = false;
        })
        .catch(({ response }) => {
          this.errors = response.data;
          this.$toast.error("خطای سرور در ویرایش پرمیشن");
          this.loadingPermissionUpdate = false;
        });
    },
    addPerm(id, serviceId) {
      let temp = this.cloneObject(this.value);
      temp[id] = { type: "active", service_id: serviceId };

      this.$emit("input", temp);
    },
    removePerm(id) {
      let temp = this.cloneObject(this.value);
      delete temp[id];
      this.$emit("input", temp);
    },
    getPermissionRoles(permissionId) {
      this.requestApiGet("admin/permissionRole", {
        permission_id: permissionId,
        role_id: this.$route.params.id,
      })
        .then((res) => {
          this.permissionRoleInfo.id = res.data.id;
          this.permissionRoleInfo.service_id = res.data.service_id;
          this.dialogPermissionRoles = true;
        })
        .catch((err) => {
          this.$toast.error("یافت نشد!");
        });
    },
    updatePermission() {
      this.requestApiPost("admin/permissionRoleUpdate", {
        id: this.permissionRoleInfo.id,
        service_id: this.permissionRoleInfo.service_id,
      })
        .then((res) => {
          this.dialogPermissionRoles = false;
          this.$toast.success("با موفقیت ویرایش شد.");
        })
        .catch((err) => {
          this.$toast.error("مشکل در ثبت سرویس!");
        });
    },
  },
};
</script>

<style scoped></style>
